import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteName } from "../utils/route.utils";
import styles from "../styles/v3.module.scss";
import Header from "../components/v3/components/Header";
import TeamHeroSection from "../components/v3/components/TeamHeroSection/TeamHeroSection";
import TeamValueSection from "../components/v3/components/TeamValueSection/TeamValueSection";
import TeamOurTeamSection from "../components/v3/components/TeamOurteamSection/TeamOurTeamSection";
import TeamRideSection from "../components/v3/components/TeamRideSection/TeamRideSection";
import TeamTimelineSection from "../components/v3/components/TeamTimelineSection/TeamTimelineSection";
import events from "../events";
import Footer from "../components/v3/components/Common/Footer";
import Head from "next/head";
import TAGS from "../public/headJson.json";

const Team = (props) => {
  const { webviewEvent } = props;
  const [windowSize, setWindowSize] = useState([]);
  const firebase_uid = useSelector((state) => state?.currentUser?.firebaseUID);

  useEffect(() => {
    if (window) {
      window.dataLayer = window.dataLayer || [];

      const eventParams = {
        firebase_uid,
        url: window.location.href,
        type: "team_page",
        date_time: new Date(),
      };
      if (webviewEvent) {
        eventParams.packageName = webviewEvent?.packageName;
        eventParams.userAgent = webviewEvent?.userAgent;
        eventParams.mobile = webviewEvent?.mobile;
        eventParams.webview = true;
      }
      window.dataLayer.push({
        event: events.WEBPAGE_OPEN,
        ...eventParams,
      });
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.team.title}</title>
        <meta name="title" content={TAGS.team.title} />
        <meta name="description" content={TAGS.team.description} />
        <link rel="canonical" href={RouteName.team} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.team} />
        <meta property="og:title" content={TAGS.team.title} />
        <meta property="og:description" content={TAGS.team.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.team} />
        <meta property="twitter:title" content={TAGS.team.title} />
        <meta property="twitter:description" content={TAGS.team.description} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />
      </Head>

      <div className={styles.v3}>
        <div className={styles.header}>
          <Header type="landing" />
        </div>
        <div className={styles.team_hero_section}>
          <TeamHeroSection windowSize={windowSize} />
        </div>
        <div className={styles.team_value_section}>
          <TeamValueSection windowSize={windowSize} />
        </div>
        <div className={styles.team_our_section}>
          <TeamOurTeamSection windowSize={windowSize} />
        </div>
        <div className={styles.team_ride_section}>
          <TeamTimelineSection windowSize={windowSize} />
        </div>
        <div className={styles.team_ride_section}>
          <TeamRideSection windowSize={windowSize} />
        </div>
        <div className="mt-20">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Team;
